import Briefcase from './Briefcase';

export default Briefcase;
